import React, { useEffect } from 'react';

import './Legend.css';

export const Legend = ({ isListView = true }) => {
  useEffect(() => {}, []);

  return (
    <>
      <div className='legend-container'>
        <div className='legend-title'>
          Circle color represents media's political ideology
        </div>
        <div className='legend-row'>
          <div className='box maroon'></div>Far left
        </div>
        <div className='legend-row'>
          <div className='box red'></div>Left
        </div>
        <div className='legend-row'>
          <div className='box orange'></div>Left center
        </div>
        <div className='legend-row'>
          <div className='box green'></div>Center
        </div>
        <div className='legend-row'>
          <div className='box darkslategray'></div>Right center
        </div>
        <div className='legend-row'>
          <div className='box blue'></div>Right
        </div>
        <div className='legend-row'>
          <div className='box navy'></div>Far right
        </div>
      </div>
      {!isListView && (
        <div className='legend-container'>
          <div className='legend-title'>
            Circle size represents media's traffic
          </div>
          <div className='legend-row'>
            <div className='box small'></div>Minimum
          </div>
          <div className='legend-row'>
            <div className='box large'></div>Maximum
          </div>
        </div>
      )}
    </>
  );
};
